<div id="app-version" (click)="openDialog()" [className]="'clickable'" style="cursor:pointer">
  <span>
    <strong>Build:</strong> {{env.buildDate}}
  </span>
  @if (apiVersionInfo && apiVersionInfo.Version) {
  <span>
    <span>
      <strong>api</strong> {{apiVersionInfo.Version}}
    </span>
    <span>
      <strong>Build:</strong> {{apiVersionInfo.BuildDate}}
    </span>
    <span>
      <strong>db</strong> {{databaseVersion.Catalog + '.' + databaseVersion.DatabaseSource}}
    </span>
    <span>
      <strong>Build:</strong> {{databaseVersion.DatabaseLastModifiedSchemaView ? databaseVersion.DatabaseLastModifiedSchemaView.LastModified : ''}}
    </span>
  </span>
  }
</div>

@if (dialogOpened) {
<kendo-dialog title="App Version Details" [width]="maxWidth * .7" [minWidth]="500" [height]="maxHeight * .6" (close)="dialogOpened=false">
  <div class="appversion">
    <h2>Version Info</h2>
    <kendo-grid #gridProperties [data]="this.info" [resizable]="true" style="height:calc( 50% - 2em)">
      <kendo-grid-column [width]="150" field="name" title=""></kendo-grid-column>
      <kendo-grid-column field="value" title=""></kendo-grid-column>
    </kendo-grid>
    <div class="row mt-1 mb-1">
      <div class="col col-xs-12 col-sm-10 h2">Errors and Warnings</div>
      <div class="col col-xs-12 col-sm-2">
        <button type="button" kendoButton (click)="clearErrors()">Clear Errors</button>
      </div>
    </div>
    <kendo-grid #gridErrors [data]="error.messageStore | async" [resizable]="true" style="height:calc( 50% - 2em)">
      <kendo-grid-column [width]="200" field="message" title="Message"></kendo-grid-column>
      <kendo-grid-column [width]="100" field="messageType" title="Type"></kendo-grid-column>
      <kendo-grid-column [width]="800" field="error" title="Error">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" style="white-space: normal;">
          {{dataItem.error}}
          @if (dataItem.subError) {
          <div>
            <hr />
            {{dataItem.subError}}
          </div>
          }
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
  <kendo-dialog-actions>
    <button type="button" kendoButton (click)="dialogOpened=false">OK</button>
  </kendo-dialog-actions>
</kendo-dialog>
}